import React, { useState, useEffect } from 'react';
import './ModiFyRegistrationDetails.css'
import Form from 'react-bootstrap/Form';
import ProjectsService from '../../Services/ProjectsService';
import ServiceRequestModel from './ServiceRequestModel';
import OtpInputModal from '../Company/OtpInputModal';
import SRQService from '../../Services/SRQService';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import InfoPopover from '../Common/InfoPopover';

const DeleteCompanyRecords = ({ onCancel }) => {

  const [isCreateSRQButtonActive, setIsCreateSRQButtonActive] = useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  var otpInputModelOpenendForAction = '';
  const [selectedRequestTypeCompany, setSelectedRequestTypeCompany] = useState('');
  const [existingCompany, setExistingCompany] = useState([]);
  const [accountAdditionalDetails, setAccountAdditionalDetails] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [responseMessage, setResponseMessage] = useState(" ");

  const handleSelectChange = (event) => {
    let eValue = event.target.value;
    //alert(eValue);
    if (eValue == "Select Existing Company") {
      setAccountAdditionalDetails("");
      setIsDisabled(true);
    } else {
      setSelectedRequestTypeCompany(eValue);
      setIsDisabled(false);
    }
  }
  const onServiceRequestCreated = () => {
    console.log("inside onServiceRequestCreated function")
    clearAllFields();
    setModalShow(false);
    window.location.href = "/viewserviceRequests";
  };
  function clearAllFields() {

  }
  const handleClearCompanySelection = () => {
    setSelectedRequestTypeCompany("");
  };

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static'
        keyboard="False"
        dialogClassName='my-modal'



      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
            Confirmation on  service request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
            {responseMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="ui button comm-button-style primary" onClick={onServiceRequestCreated}>OK</button>
        </Modal.Footer>
      </Modal>
    );
  }


  async function createSRQ() {
    setIsCreateSRQButtonActive(true);
    otpInputModelOpenendForAction = "registerCompany";
    setOtpModalOpen(true);

    // 
    try {
      const response = await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null);
      if (response && response.data.channel == "SMS") {
        otpInputModelOpenendForAction = "registerCompany";


        setOtpModalOpen(true);
        // alert("otp entered from otp modal for deleting credentials is ---->" + OtpDataFromModal);
      }


    } catch (error) {
      console.log(error);
    }
    // setModalShow(true);  //enable here for modal testing

  }

  const resendOtp = async () => {
    await ProjectsService.getStrongConfirmationCode("POST", null, "registerCompany", null, null, null);
  }

  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }

  async function verifyOtp(OtpDataFromModal) {

    if (OtpDataFromModal.length !== 0) {

      console.log(OtpDataFromModal)
      OtpDataFromModal = Number(OtpDataFromModal.join(''));
      ServiceRequestModel.companyId = selectedRequestTypeCompany;
      ServiceRequestModel.requestType = "DeleteCompany";
      ServiceRequestModel.requestText = accountAdditionalDetails.replace(/(?:\r\n|\r|\n)/g, ' ');
      console.log(ServiceRequestModel);
      const response = await SRQService.createNewServiceRequest(ServiceRequestModel, OtpDataFromModal)
        .then((response) => {
          setResponseMessage(response.data.message);
          setModalShow(true);
          setOtpModalOpen(false);
        }).catch(error => {
          // Check if it's an APIM error - let global interceptor handle those
          if (error.response?.data?.code?.startsWith('APIM-')) {
            console.log('APIM error, letting global interceptor handle it');
          } else {
            toast.error(error.response.data.message, {

              position: toast.POSITION.BOTTOM_RIGHT,

              autoClose: 8000, //6 seconds

              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
          }
          console.log(error);
        });

    }

  }


  useEffect(() => {
    ProjectsService.getAllProjects().then((response) => {
      setExistingCompany(response.data[0].companyProjects);
    }).catch(error => {
      console.log(error);
    });
  }, [])

  const customstyles = {
    dropdownindicator: base => ({
      ...base,
      fill: "red" // custom colour
    })
  };


  const handleCancel = () => {
    clearAllFields();

    if (onCancel) {
      onCancel();
    }
  }



  return (
    <>
      <li>
        <div className="sec">
          <div className="head-titlw-w head-titl-unset" style={{ maxWidth: '44%' }}>
            <h3
              style={{ fontSize: "16px" }}
              className="sec-title"
              id="ManageCompany-ModifyCompany-promptForModifyCompany"
              data-info=""
            >
              DELETE COMPANY RECORDS
            </h3>
          </div>
          <ul className="serv-req sec-inner-wrap">
            <li>
              <div
                className="dropdown-w-info mt-3"
                id="selectModifyCompanyWrapper"
                style={{ display: "flex" }}
              >
                {selectedRequestTypeCompany ? (

                  <span
                    id='clear-icon-DelCompanyRecord-company'
                    className="clear-icon-DelCompanyRecord-company no-ligatures"
                    onClick={handleClearCompanySelection}
                  >
                    &times;
                  </span>
                ) : (
                  <i className="dropdown icon" />
                )}
                <div className="width-full">
                  <Form.Select
                    defaultValue="Select Existing Company"
                    value={selectedRequestTypeCompany}
                    onChange={handleSelectChange}
                    styles={customstyles}
                    style={{ width: "100%" }}
                    className={selectedRequestTypeCompany ? 'dropdown-with-close' : 'dropdown-default'}
                  >
                    <option className="textdefault">
                      {"Select Existing Company"}
                    </option>

                    {existingCompany &&
                      existingCompany.map((cp) => {
                        //alert(cp.name);
                        return <option value={cp.id}>{cp.name}</option>;
                      })}
                  </Form.Select>

                  <span className="required-field-op">(Required)</span>
                </div>
                <InfoPopover
                  id="infoPopOverModifyCompany"
                  className="info-icon-w ms-2"
                  content="Please select the company to remove."
                  ariaLabel="Information: select company to remove"
                />
              </div>
            </li>

            <>
              <div className="awesome">
                <ul className="serv-req sec-inner-wrap">


                  <li>
                    <div className="custom-input-wrapp mt-3 mb-3">
                      <div className="dropdown-w-info">
                        <div className="width-full">
                          <textarea
                            className="cust-text-a"
                            maxLength={4000}
                            placeholder="Additional Details"
                            id="textAreaModifyAdditionalDetails"
                            tabIndex={1}
                            value={accountAdditionalDetails}
                            onChange={(e) =>
                              setAccountAdditionalDetails(e.target.value)
                            }
                            disabled={!selectedRequestTypeCompany || selectedRequestTypeCompany === ""}
                          />
                        </div>
                        <InfoPopover
                          id="infoPopOverModifyAdditionalDetails"
                          className="info-icon-w pop-common-sel sr-pophover ms-2"
                          content="Please provide reason and any additional details relevant to the removal."
                          ariaLabel="Information: additional details"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          </ul>
        </div>
      </li>
      <li className="apim-pop-button-w comm-button-wrap ser-req-btn">
        {(!isCreateSRQButtonActive && !isDisabled) ?
          <button
            className="comm-button-style primary btn-disable"
            tabIndex={1}
            onClick={() => createSRQ()}
          >
            Create
          </button> :
          <button className="button comm-button-style primary btn-disable" id="btnSubmitRegisterCompany" tabindex="1"
            disabled>{!isCreateSRQButtonActive ? <>Create</> : <>Creating Service Request..</>}</button>
        }
        <button
          type="button"
          className="button comm-button-style secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </li>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
      {OtpModalOpen && <OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal} verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpInputModelOpenendForAction} resendOtp={resendOtp} />}

    </>
  );
}
export default DeleteCompanyRecords;